import HttpRequest from "./HttpRequest";
import Helper, {IHttpClientResponseBag, IHttpClientResponseLowerCase} from "../Helpers/Helper";

export interface IGetRolesRequest {
    TemplateId: string
    Id: string
    Mode: string
}

export interface IGetRolesResponse {
    Id: number
    TemplateId: number
    ApprovalStepId: number
    ApprovalStepName: string
    RoleName: string
}

export interface IDeleteRolesRequest {
    TemplateId: string
    Id: string
    ApprovalStepId: string
}

export interface IPostRolesRequest {
    TemplateId: string
    Id?: number
    RoleName: string
}


const RolesService = {


    /**
     * Get Roles
     * @param request
     */

    getRoles: async (request: IGetRolesRequest): Promise<IHttpClientResponseBag> => {
        const {data}: any = await HttpRequest.getWithSession('roles', request)

        return new Promise<IHttpClientResponseBag>((resolve, reject) => {
            if (!data.success) reject(Helper.GetErrorFromResponse(data))
            resolve(JSON.parse(data.result) as IHttpClientResponseBag)
        })
    },

    /**
     * Delete Roles
     * @param request
     */

    deleteRoles: async (request: IDeleteRolesRequest): Promise<IHttpClientResponseLowerCase> => {
        const {data}: any = await HttpRequest.deleteWithSession('roles', request)

        return new Promise<IHttpClientResponseLowerCase>((resolve, reject) => {
            if (!data.success) reject(Helper.GetErrorFromResponse(data))
            resolve(Helper.keysToLowerCase(data) as IHttpClientResponseLowerCase)
        })
    },


    /**
     * Sends a POST request to create or update roles using the specified request data
     * and returns a promise with the response in lowercase keys format.
     *
     * @param {IPostRolesRequest} request - The request payload containing role information
     */

    postRoles: async (request: IPostRolesRequest): Promise<IHttpClientResponseLowerCase> => {
        const {data}: any = await HttpRequest.postWithSession('roles', request)

        return new Promise<IHttpClientResponseLowerCase>((resolve, reject) => {
            if (!data.success) reject(Helper.GetErrorFromResponse(data))
            resolve(Helper.keysToLowerCase(data) as IHttpClientResponseLowerCase)
        })
    }


}

export default RolesService
